var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcAffirm = function SvgCcAffirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060809",
    fillRule: "evenodd",
    d: "M15.134 12.47h-1.109v-.436c0-.566.324-.728.603-.728.308 0 .547.137.547.137l.378-.863s-.383-.25-1.079-.25c-.782 0-1.672.44-1.672 1.824v.315h-1.856v-.435c0-.566.323-.728.602-.728.158 0 .371.037.548.137l.377-.863c-.225-.133-.587-.25-1.078-.25-.782 0-1.672.44-1.672 1.824v.315h-.71v.944h.71v3.336h1.223v-3.336h1.856v3.336h1.223v-3.336h1.11v-.944Zm2.98-.001v4.28h1.224v-2.062c0-.98.593-1.268 1.007-1.268.161 0 .38.046.523.154l.224-1.131a1.398 1.398 0 0 0-.55-.099c-.629 0-1.024.28-1.285.845v-.719h-1.143Zm-11.91 3.512c-.32 0-.48-.158-.48-.42 0-.482.54-.648 1.526-.752 0 .646-.436 1.172-1.045 1.172Zm.426-3.638c-.705 0-1.516.333-1.957.684l.403.847c.353-.324.924-.6 1.44-.6.489 0 .76.164.76.493 0 .223-.18.334-.519.378-1.264.165-2.257.514-2.257 1.489 0 .773.55 1.24 1.41 1.24.614 0 1.16-.34 1.42-.79v.665h1.143v-2.787c0-1.151-.8-1.619-1.843-1.619Zm18.753.752c.252-.369.736-.751 1.383-.751.782 0 1.43.485 1.43 1.447v2.958h-1.224v-2.571c0-.567-.341-.802-.664-.802-.405 0-.81.37-.81 1.17v2.203h-1.223v-2.563c0-.584-.321-.81-.671-.81-.387 0-.8.379-.8 1.17v2.203h-1.225v-4.28h1.18v.648c.206-.414.654-.773 1.301-.773.594 0 1.09.274 1.323.751Zm-8.296 3.654h-1.222v-4.28h1.222v4.28Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FA0EA",
    fillRule: "evenodd",
    d: "M22.993 6.5c-3.303 0-6.248 2.293-7.084 5.242h1.198c.698-2.196 3.067-4.123 5.886-4.123 3.427 0 6.388 2.608 6.388 6.67 0 .911-.118 1.733-.341 2.46H30.2l.012-.04c.19-.75.287-1.563.287-2.42 0-4.53-3.3-7.789-7.507-7.789Z",
    clipRule: "evenodd"
  })));
};
export default SvgCcAffirm;